<router-outlet></router-outlet>
@if (showFooter | async) {
  <footer class="app-footer">
    <p>
      <a routerLink="/politicas-privacidad">Políticas de Privacidad</a>
    </p>
  </footer>
}